<section class="content-header">
  <div class="container-fluid"><h1>Premium</h1></div>
</section>

<section class="content">
  <div class="container-fluid">
    <div *ngIf="message" class="alert alert-success">{{ message }}</div>
    <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

    <ul class="nav nav-tabs mb-3">
      <li class="nav-item"><a class="nav-link" [class.active]="tab==='codes'" href="javascript:void(0)" (click)="setTab('codes')">Promosyon Kodları</a></li>
      <li class="nav-item"><a class="nav-link" [class.active]="tab==='users'" href="javascript:void(0)" (click)="setTab('users')">Kullanıcı Premium</a></li>
      <li class="nav-item"><a class="nav-link" [class.active]="tab==='events'" href="javascript:void(0)" (click)="setTab('events')">Webhook Olayları</a></li>
    </ul>

    <!-- PROMO CODES -->
    <div *ngIf="tab==='codes'">
      <div class="card">
        <div class="card-header">Yeni bedava premium kodu</div>
        <div class="card-body">
          <div class="form-row">
            <div class="form-group col-md-4">
              <label>Kod (boş bırakırsan rastgele üretilir)</label>
              <input class="form-control" [(ngModel)]="newCode.code" placeholder="ör. YAZ2026">
            </div>
            <div class="form-group col-md-4">
              <label>Açıklama</label>
              <input class="form-control" [(ngModel)]="newCode.description">
            </div>
            <div class="form-group col-md-2">
              <label>Süre (gün, boş = ömür boyu)</label>
              <input type="number" min="1" class="form-control" [(ngModel)]="newCode.durationDays">
            </div>
            <div class="form-group col-md-2">
              <label>Maks. kullanım (boş = sınırsız)</label>
              <input type="number" min="1" class="form-control" [(ngModel)]="newCode.maxRedemptions">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-3">
              <label>Geçerlilik başlangıcı</label>
              <input type="date" class="form-control" [(ngModel)]="newCode.validFrom">
            </div>
            <div class="form-group col-md-3">
              <label>Geçerlilik bitişi</label>
              <input type="date" class="form-control" [(ngModel)]="newCode.validUntil">
            </div>
          </div>
          <button class="btn btn-primary" (click)="createCode()">Oluştur</button>
        </div>
      </div>

      <div class="card">
        <div class="card-body table-responsive p-0">
          <table class="table table-hover">
            <thead><tr><th>Kod</th><th>Açıklama</th><th>Süre</th><th>Kullanım</th><th>Geçerlilik</th><th>Aktif</th><th></th></tr></thead>
            <tbody>
              <tr *ngFor="let c of codes">
                <td><code>{{ c.code }}</code></td>
                <td>{{ c.description }}</td>
                <td>{{ c.durationDays ? c.durationDays + ' gün' : 'Ömür boyu' }}</td>
                <td>{{ c.redeemedCount }} / {{ c.maxRedemptions || '∞' }}</td>
                <td>{{ (c.validFrom | date:'shortDate') || '—' }} – {{ (c.validUntil | date:'shortDate') || '—' }}</td>
                <td><input type="checkbox" [checked]="c.active" (change)="toggleCode(c)"></td>
                <td class="text-right"><button class="btn btn-sm btn-outline-primary" (click)="showRedemptions(c)">Kullanımlar</button></td>
              </tr>
              <tr *ngIf="codes.length===0"><td colspan="7" class="text-muted">Kod yok.</td></tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="card" *ngIf="selectedCode">
        <div class="card-header">{{ selectedCode.code }} kullanımları</div>
        <div class="card-body table-responsive p-0">
          <table class="table table-hover">
            <thead><tr><th>Kullanıcı</th><th>Tarih</th><th>Hak durumu</th><th>Bitiş</th><th></th></tr></thead>
            <tbody>
              <tr *ngFor="let r of redemptions">
                <td>{{ r.email }} <small class="text-muted">({{ r.nickname }})</small></td>
                <td>{{ r.redeemedAt | date:'short' }}</td>
                <td>{{ r.entitlementStatus }}</td>
                <td>{{ (r.expiresAt | date:'short') || 'Ömür boyu' }}</td>
                <td class="text-right"><button class="btn btn-sm btn-outline-danger" [disabled]="r.entitlementStatus==='Revoked'" (click)="revoke(r.entitlementId)">Hakkı iptal et</button></td>
              </tr>
              <tr *ngIf="redemptions.length===0"><td colspan="5" class="text-muted">Kullanım yok.</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- USERS -->
    <div *ngIf="tab==='users'">
      <div class="card">
        <div class="card-body">
          <div class="input-group">
            <input class="form-control" placeholder="E-posta ara" [(ngModel)]="userQuery" (keyup.enter)="search()">
            <div class="input-group-append"><button class="btn btn-primary" (click)="search()">Ara</button></div>
          </div>
          <ul class="list-group mt-3" *ngIf="hits.length">
            <li class="list-group-item list-group-item-action" *ngFor="let u of hits" (click)="pickUser(u)" style="cursor:pointer">
              {{ u.email }} <small class="text-muted">({{ u.nickname }}, #{{ u.id }})</small>
            </li>
          </ul>
        </div>
      </div>

      <div *ngIf="selectedUser">
        <div class="card">
          <div class="card-header">{{ selectedUser.email }}: premium hakları</div>
          <div class="card-body table-responsive p-0">
            <table class="table table-hover">
              <thead><tr><th>Kaynak</th><th>Ürün</th><th>Durum</th><th>Başlangıç</th><th>Bitiş</th><th>Not</th><th></th></tr></thead>
              <tbody>
                <tr *ngFor="let e of entitlements">
                  <td>{{ e.source }} <small class="text-muted">{{ e.environment }}</small></td>
                  <td>{{ e.productId }}</td>
                  <td>{{ e.status }}</td>
                  <td>{{ e.startsAt | date:'short' }}</td>
                  <td>{{ (e.expiresAt | date:'short') || 'Ömür boyu' }}</td>
                  <td>{{ e.note }}</td>
                  <td class="text-right">
                    <button class="btn btn-sm btn-outline-danger" *ngIf="e.source!=='RevenueCat'" [disabled]="e.status==='Revoked'" (click)="revoke(e.id)">İptal</button>
                  </td>
                </tr>
                <tr *ngIf="entitlements.length===0"><td colspan="7" class="text-muted">Hak yok.</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="card">
          <div class="card-header">Elle premium ver</div>
          <div class="card-body">
            <div class="form-row">
              <div class="form-group col-md-3">
                <label>Süre (gün)</label>
                <input type="number" min="1" class="form-control" [(ngModel)]="grantDays" [disabled]="grantLifetime">
              </div>
              <div class="form-group col-md-3 d-flex align-items-end">
                <div class="form-check mb-2">
                  <input type="checkbox" class="form-check-input" id="lt" [(ngModel)]="grantLifetime">
                  <label for="lt" class="form-check-label">Ömür boyu</label>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label>Not (zorunlu)</label>
                <input class="form-control" [(ngModel)]="grantNote" placeholder="Neden veriliyor?">
              </div>
            </div>
            <button class="btn btn-primary" (click)="grant()" [disabled]="!grantNote.trim() || (!grantLifetime && (!grantDays || grantDays < 1))">Ver</button>
          </div>
        </div>
      </div>
    </div>

    <!-- WEBHOOK EVENTS -->
    <div *ngIf="tab==='events'">
      <div class="card">
        <div class="card-body">
          <div class="form-inline">
            <label class="mr-2">Sonuç</label>
            <select class="form-control mr-2" [(ngModel)]="eventFilter" (change)="loadEvents()">
              <option value="">Hepsi</option>
              <option value="Applied">Applied</option>
              <option value="Ignored">Ignored</option>
              <option value="Unmatched">Unmatched</option>
              <option value="Error">Error</option>
              <option value="Pending">Pending</option>
            </select>
            <button class="btn btn-outline-secondary" (click)="loadEvents()"><i class="fas fa-sync"></i> Yenile</button>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body table-responsive p-0">
          <table class="table table-hover">
            <thead><tr><th>Alındı</th><th>Tür</th><th>App user</th><th>Sonuç</th><th>Hata</th><th></th></tr></thead>
            <tbody>
              <tr *ngFor="let ev of events">
                <td>{{ ev.receivedAt | date:'short' }}</td>
                <td>{{ ev.type }}</td>
                <td><small>{{ ev.appUserId }}</small></td>
                <td>{{ ev.result }}</td>
                <td><small>{{ ev.error }}</small></td>
                <td class="text-right">
                  <button class="btn btn-sm btn-outline-primary" *ngIf="ev.result==='Unmatched' || ev.result==='Error'" (click)="reprocess(ev)">Yeniden işle</button>
                </td>
              </tr>
              <tr *ngIf="events.length===0"><td colspan="6" class="text-muted">Olay yok.</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
